import React from 'react';

import StoreTile from './store-tile';

const StoreCard = ({
    name, styles, logo, description,
}) => (
    <div className={styles.storeCard}>
        <div>
            <StoreTile name={name} styles={styles.storeTileCard} logo={logo} />
        </div>
        <div style={{ textAlign: 'center' }}><span className={styles.storeTileText}>{name}</span></div>
        {/* description && (
            <div>{description}</div>
        ) */}
        { /* <div><span className={styles.storeTileText}>★★★★★</span></div> */ }
    </div>
);

export default StoreCard;



/** WEBPACK FOOTER **
 ** ./src/components/store-card.jsx
 **/